import React from 'react';
import PropTypes from 'prop-types';
import './PointValueDisplay.css';

function PointValueDisplay({ label, icon, pointValue, scale = false }) {
  const hasIcon = !!icon;
  return (
    <div
      className={`point-value-container ${hasIcon ? 'has-icon' : ''}`.trim()}
    >
      {label ? <p className="value-label">{label}</p> : icon}
      <div className="point-value-display">
        <span className={scale ? 'growing' : ''}>
          {pointValue.toLocaleString()}
        </span>
      </div>
    </div>
  );
}

PointValueDisplay.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.element,
  pointValue: PropTypes.number.isRequired,
  scale: PropTypes.bool
};

export default PointValueDisplay;



// WEBPACK FOOTER //
// ./src/components/PointValueDisplay/index.js